import { TimeIcon } from 'foundations-assets';
import { SLAStatus } from 'find-and-filter-data/view-members-schema/types';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
const getColorMap = status => {
  switch (status) {
    case SLAStatus.IN_SLA:
      return {
        borderStyle: 'unset',
        borderWidth: '0',
        backgroundColor: undefined,
        color: 'icon-core-subtle'
      };
    case SLAStatus.SLA_WARNING:
      return {
        color: 'icon-caution-default',
        backgroundColor: 'fill-caution-subtle'
      };
    case SLAStatus.BREACHED:
      return {
        backgroundColor: 'fill-alert-default',
        color: 'icon-core-on-fill-default',
        borderColor: 'border-alert-default'
      };
    case SLAStatus.RESOLVED_IN_SLA:
    case SLAStatus.RESOLVED_OUTSIDE_SLA:
      return {
        color: undefined,
        backgroundColor: undefined
      };
    default:
      return {};
  }
};
const PreviewCardSLAIcon = ({
  status = SLAStatus.IN_SLA
}) => {
  if (!status) return null;
  const {
    color,
    backgroundColor,
    borderColor,
    borderWidth,
    borderStyle
  } = PreviewCardSLAIcon.getColorMap(status);
  return /*#__PURE__*/_jsx(IconCircle, {
    icon: TimeIcon,
    "data-test-id": "sla-icon",
    color: color,
    backgroundColor: backgroundColor,
    size: '100',
    padding: '50',
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderStyle: borderStyle
  });
};
PreviewCardSLAIcon.getColorMap = getColorMap;
PreviewCardSLAIcon.displayName = 'PreviewCardSLAIcon';
export default PreviewCardSLAIcon;